import React from "react";
import PropTypes from "prop-types";
import { Flex } from "rebass";
import styled, { css } from "styled-components/macro";
import { ifNotProp, ifProp, switchProp } from "styled-tools";
import { ReactComponent as CloseIcon } from "../Modal/_/icon-close.svg";

const Container = styled(Flex)`
  ${switchProp("variant", {
    default: css`
      color: ${props => props.theme.colors.white};
      border-color: ${props => props.theme.colors.white};
    `,
    dark: css`
      color: ${props => props.theme.colors.dark};
      border-color: ${props => props.theme.colors.dark};
    `,
  })};
  ${ifNotProp(
    "icononly",
    css`
      border-width: 2px;
      border-style: solid;
      border-radius: 100%;
    `,
  )}
  width: 48px;
  height: 48px;
`;
const Button = styled.button.attrs({
  "data-testid": "CloseButton",
})`
  position: absolute;
  top: ${ifProp("icononly", "15px", "30px")};
  right: ${ifProp("icononly", "15px", "20px")};

  ${p => p.theme.upFrom.md`
    right: 30px;
  `};

  cursor: pointer;
  appearance: none;
  background: none;
  border: none;
  margin: 0;
  padding: 0;
`;

export const CloseButton = ({ onClick, icononly, variant, ...props }) => (
  <Button {...props} onClick={onClick} icononly={icononly} variant={variant}>
    <Container
      alignItems="center"
      justifyContent="center"
      icononly={icononly}
      variant={variant}
    >
      <CloseIcon />
    </Container>
  </Button>
);

CloseButton.defaultProps = {
  icononly: false,
  variant: "default",
};

CloseButton.propTypes = {
  icononly: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(["default", "dark"]),
};

export default CloseButton;
